import { numAlphabetOnlyRegex, patientNameRegex } from "../../constants/Regex";

export const rules = {
patientLastName : {
  pattern: {
    value: patientNameRegex,
    message: "Please enter valid last name.",
  },
},
  subscriberId: {
    pattern: {
      value: numAlphabetOnlyRegex,
      message: "Please enter valid subscriber ID.",
    },
    maxLength: { value: 15, message: "15 characters or digits is allowed" },
  },
}